// eslint-disable-next-line no-unused-vars
import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import { defineMessages, injectIntl } from "react-intl";
import { withStyles } from "@material-ui/core";
import { Link } from "react-router-dom";

import HUBContext from "../../../../services/HUBContext";
import { ROUTER_MAP_PATH } from "../../../../EmbeddedRoutes";
import { DV3SearchIcon } from "../../../../common/icons";
import { Input, Table } from "antd";
import { styles } from "./VehicleSingleRegistrySyncHistoryWidget.styles";
import { translations } from "./constants";
import { trackEvent } from "../../../../services/telemetry/appInsights";
import HandleAPI from "../../../../helpers/handleAPI";
import { getSynchronizedHistory } from "../../../../services/api/hubcatalog/one-mobility-single-registry-service";
import { VehicleSingleRegistrySyncHistoryPageBase } from "../../admin/VehicleSingleRegistrySyncHistoryPage/VehicleSingleRegistrySyncHistoryPage";
import CustomPaginatorWidget from "../CustomPaginatorWidget/CustomPaginatorWidget";

const messages = defineMessages(translations);
const defaultPageSize = 5;

export class VehicleSingleRegistrySyncHistoryWidget extends VehicleSingleRegistrySyncHistoryPageBase {
  getBackURL() {
    return ROUTER_MAP_PATH.vehicles.homePage.replace(
      ":cid",
      this.context?.company?.companyID,
    );
  }

  getDefaultPageSize() {
    return defaultPageSize;
  }

  handleSearchSubmit = () => {
    const { response, search } = this.state;
    this.getData(
      response?.pageSize || this.getDefaultPageSize(),
      0,
      response?.sortProperty,
      response?.sortDirection,
      search,
    );
  };

  handleSearchChange = (e) => {
    this.setState({ search: e.target.value });
  };

  onSearchEnter = (e) => {
    const value = e.target?.value || this.state.search;

    if (this.state.search !== value) {
      this.setState({ search: value }, this.handleSearchSubmit);
    } else {
      this.handleSearchSubmit();
    }
  };

  onTableChange = (_, __, sorter) => {
    const { response, search } = this.state;
    const sortProperty = sorter.field;
    const sortDirection = sorter.order === "descend" ? "desc" : "asc";

    this.getData(
      response?.pageSize || this.getDefaultPageSize(),
      0,
      sortProperty,
      sortDirection,
      search,
    );
  };

  getData = (take, skip, sortProperty, sortDirection, search) => {
      if (!this.mount) return;
  
      const { intl, alert } = this.props;
      const { response, appliedFilters } = this.state;
      const { company } = this.context;
  
      if (!company?.companyID) return;
  
      let pageSize = take || response?.pageSize || this.getDefaultPageSize();
      let pageIndex =
        !response?.data && !response?.items
          ? 0
          : parseInt((skip || 0) / pageSize);
  
      const filters = {
        search: search || "",
        status: appliedFilters?.status || "",
        platform: appliedFilters?.platform || "",
        operation: appliedFilters?.operation || "",
        pageIndex,
        pageSize,
        sortProperty: sortProperty || "latestUpdate",
        sortDirection: sortDirection || "desc",
      };
  
      if (search) {
        trackEvent("OneMobilitySingleRegistry_SyncHistorySearched", {
          companyId: company?.companyID,
          searchPlate: search,
        });
      }
  
      if (
        appliedFilters?.status ||
        appliedFilters?.platform ||
        appliedFilters?.operation
      ) {
        trackEvent("OneMobilitySingleRegistry_SyncHistoryFiltersApplied", {
          companyId: company?.companyID,
          status: appliedFilters?.status || null,
          platform: appliedFilters?.platform || null,
          operation: appliedFilters?.operation || null,
        });
      }
  
      this.setState({ loading: true });
  
      getSynchronizedHistory(company?.companyID || 0, filters)
        .then((r) => {
          if (!this.mount) return;
          this.setState({ loading: false, response: r.data });
        })
        .catch((error) => {
          if (!this.mount) return;
          this.setState({ loading: false });
          HandleAPI(error, alert, intl);
        });
    };

    componentDidMount() {
        this.mount = true;
        const { company } = this.context;
        const { match } = this.props;
    
        trackEvent("OneMobilitySingleRegistry_SyncHistoryOpened", {
          companyId: match.params.cid,
        });
    
        this.setState(
          {
            companyID: company?.companyID || 0,
          },
          () => {
            if (this.state.companyID > 0) this.getData();
          },
        );
      }

    componentDidUpdate() {
      if (!this.mount) return;

      const { match } = this.props;
      const { companyID } = this.state;
      const { company, setCompanyID } = this.context;

      const inUrlCompanyID = isNaN(match.params.cid)
        ? 0
        : parseInt(match.params.cid);

      if (!!company) {
        if (inUrlCompanyID !== company.companyID) {
          typeof setCompanyID === "function" && setCompanyID(inUrlCompanyID);
        } else if (company.companyID !== companyID) {
          this.setState({ companyID: company.companyID }, () => {
            this.getData();
          });
        }
      }
    }

  render() {
    const { intl, classes } = this.props;
    const { search, response } = this.state;

    return (
      <div className={classes.page}>
        <div className={classes.cardHeader}>
          <span className={classes.subtitleText}>
            {intl.formatMessage(messages.subtitle)}
          </span>
        </div>

        <div className={classes.pageContent}>
          <div className={`filters-area ${classes.filtersArea}`}>
            <div className={`filters-area-search ${classes.filtersSearch}`}>
              <Input
                value={search}
                onChange={this.handleSearchChange}
                onPressEnter={this.onSearchEnter}
                placeholder={intl.formatMessage(messages.searchPlaceholder)}
                addonAfter={<DV3SearchIcon onClick={this.handleSearchSubmit} />}
              />
            </div>
          </div>
          <div className={`table-area ${classes.tableArea}`}>
            <Table
              pagination={false}
              scroll={{ x: true }}
              dataSource={
                Array.isArray(response)
                  ? response
                  : response?.data || response?.items || []
              }
              columns={this.columns(intl).filter((x) => !!x)}
              onChange={this.onTableChange}
              rowKey={(record, index) => index}
            />

            <CustomPaginatorWidget
              pagerInfo={response}
              onChange={(current) =>
                this.getData(
                  response?.pageSize || this.getDefaultPageSize(),
                  (current > 0 ? current - 1 : 0) *
                    (response?.pageSize || this.getDefaultPageSize()),
                  response?.sortProperty,
                  response?.sortDirection || "asc",
                  response?.search,
                )
              }
              onShowSizeChange={(current, size) =>
                this.getData(
                  size,
                  (current > 0 ? current - 1 : 0) * size,
                  response?.sortProperty,
                  response?.sortDirection || "asc",
                  response?.search,
                )
              }
            />
          </div>

          <div className={classes.backContent}>
            <hr className={classes.divider} />

            <div className={classes.backLink}>
              <Link className="v3-button" to={this.getBackURL()}>
                <span>{intl.formatMessage(messages.goBack)}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

VehicleSingleRegistrySyncHistoryWidget.contextType = HUBContext;
VehicleSingleRegistrySyncHistoryWidget = withRouter(
  injectIntl(VehicleSingleRegistrySyncHistoryWidget),
);
VehicleSingleRegistrySyncHistoryWidget = withStyles(styles)(
  VehicleSingleRegistrySyncHistoryWidget,
);

export default VehicleSingleRegistrySyncHistoryWidget;
